export default __webpack_public_path__ + "static/media/section-img.521819cf.png";